import React, { memo } from "react";
import { Box, Grid, InputLabel, Typography } from "@mui/material";
import dayjs from "dayjs";
import { Data } from "../../../store/pos/types";
import { FormikProps, useFormikContext } from "formik";
import { PosInterfaces } from "./PosConstants";
import pageStyles from "../../pageStyles";

const commaSeparated = (items: string[]) => {
  return items
    .reduceRight((acc, curr) => {
      return `${curr}, ${acc}`;
    }, "")
    .trim()
    .slice(0, -1);
};

const timeDiff = (diff: number): string =>
  ((diff / 1000 / 60 / 60) as unknown) as string;

const CommonFields = () => {
  const formikProps = useFormikContext();
  const { values } = formikProps as FormikProps<Data>;
  const classes = pageStyles();

  return (
    <>
      <Grid item xs={12}>
        <Box className={classes.dashedBox}>
          <InputLabel shrink>
            POS is currently paired with POI Device
          </InputLabel>
          <Box>
            <Typography id="tid">{values.attributes.TID}</Typography>
          </Box>
        </Box>
      </Grid>

      {values.attributes.Interface === PosInterfaces.NEXO && (
        <>
          <Grid item xs={12}>
            <Box display="flex" justifyContent="space-evenly">
              <Box className={classes.dashedBox} mr={2}>
                <InputLabel id="time-diff" shrink>
                  POS Local Time
                </InputLabel>
                <Box>
                  <Typography>
                    {values.attributes.TimeDiff
                      ? ` ${timeDiff(values.attributes.TimeDiff)} hours`
                      : ""}
                  </Typography>
                </Box>
              </Box>
              <Box className={classes.dashedBox}>
                <InputLabel shrink>Last Logout at </InputLabel>
                <Box>
                  <Typography>
                    {values.attributes.LoggedOut
                      ? dayjs(values.attributes.LoggedOut).format(
                          "DD MMM YYYY hh:mm:ss a"
                        )
                      : "Start-up"}
                  </Typography>
                </Box>
              </Box>
            </Box>
          </Grid>

          <Grid item xs={12}>
            <Box display="flex" justifyContent="space-evenly">
              <Box className={classes.dashedBox} mr={2}>
                <InputLabel shrink>Terminal Environment</InputLabel>
                <Box>
                  <Typography>
                    {values.attributes.TerminalEnvironment}
                  </Typography>
                </Box>
              </Box>
              <Box className={classes.dashedBox}>
                <InputLabel shrink>Sale Capabilities</InputLabel>
                <Box>
                  <Typography>
                    {commaSeparated(values.attributes.SaleCapabilities || [])}
                  </Typography>
                </Box>
              </Box>
            </Box>
          </Grid>

          <Grid item xs={12}>
            <hr className={classes.devide} />
            <Typography variant="overline" display="block" gutterBottom>
              Default Session Information
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Box display="flex" justifyContent="space-evenly">
              <Box className={classes.dashedBox} mr={2}>
                <InputLabel shrink>Totals Group ID</InputLabel>
                <Box>
                  <Typography>{values.attributes.TotalsGroupID}</Typography>
                </Box>
              </Box>
              <Box className={classes.dashedBox} mr={2}>
                <InputLabel shrink>Operator ID</InputLabel>
                <Box>
                  <Typography>{values.attributes.OperatorID}</Typography>
                </Box>
              </Box>
              <Box className={classes.dashedBox}>
                <InputLabel shrink>Shift Number</InputLabel>
                <Box>
                  <Typography>{values.attributes.ShiftNumber}</Typography>
                </Box>
              </Box>
            </Box>
          </Grid>
        </>
      )}
    </>
  );
};

export default memo(CommonFields);
